import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GalleryService } from '../../../services/gallery.service';
import { GalleryApiItem } from '../../../models/gallery.model';
import { Loading } from '../../layouts/loading/loading';

@Component({
  selector: 'app-galerie',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, TranslatePipe, Loading],
  templateUrl: './galerie.html',
  styleUrl: './galerie.css',
})
export class GalerieComponent implements OnInit {
  galleries: GalleryApiItem[] = [];
  loading    = true;
  error      = '';
  page       = 1;
  totalPages = 1;

  // Filtre par type
  activeFilter: 'all' | 'image' | 'video' = 'all';

  constructor(private galleryService: GalleryService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error   = '';
    this.galleryService.getGalleries(this.page, 12).subscribe({
      next: res => {
        this.galleries  = res.data ?? [];
        this.totalPages = res.meta?.last_page ?? 1;
        this.loading    = false;
      },
      error: () => {
        this.error   = 'galerie_erreur_chargement';
        this.loading = false;
      },
    });
  }

  setFilter(f: 'all' | 'image' | 'video'): void {
    this.activeFilter = f;
  }

  get filtered(): GalleryApiItem[] {
    if (this.activeFilter === 'all') return this.galleries;
    return this.galleries.filter(g => g.type === this.activeFilter);
  }

  loadPage(p: number): void {
    if (p < 1 || p > this.totalPages) return;
    this.page = p;
    this.load();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getFeatured(g: GalleryApiItem): string {
    if (g.featured_image) return g.featured_image;
    if (g.gallery?.length) return g.gallery[0].thumb || g.gallery[0].url;
    return '/assets/images/default_image.png';
  }

  getCount(g: GalleryApiItem): number {
    return g.gallery?.length ?? 0;
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }
}
